import React from "react";
import LinearProgress from "@mui/material/LinearProgress";

const LinearLoadingState = () => {
  return <LinearProgress />;
};

export default LinearLoadingState;